<template>
  <div class="index page" @touchmove.prevent>
    <div class="sign-tools">
      <div class="btn-clear" @click="canvasClear">重新签写</div>
    </div>
    <div class="sign-canvas">
      <sign-canvas
        class="sign-panel"
        ref="SignCanvas"
        :options="options"
        v-model="value"
      />
    </div>
    <div class="sign-header">
      <nav-bar
        title="请在下方空白处签字"
        left-text="返回"
        right-text="完成"
        left-arrow
        @click-left="goBack"
        @click-right="saveAsImg"
        :fixed="false"
        :placeholder="false"
      />
    </div>
  </div>
</template>
<script>
import { NavBar, Toast } from "vant";
import SignCanvas from "sign-canvas";
import { uploadImage } from "@api/user";

export default {
  components: { NavBar, SignCanvas },
  props: {},
  data: function () {
    return {
      value: null,
      loading: false,
      options: {
        isFullScreen: false, //是否全屏手写 [Boolean] 可选
        isFullCover: false, //是否全屏模式下覆盖所有的元素 [Boolean] 可选
        isDpr: true, //是否使用dpr兼容高倍屏 [Boolean] 可选
        lastWriteSpeed: 1, //书写速度 [Number] 可选
        lastWriteWidth: 2, //下笔的宽度 [Number] 可选
        lineCap: "round", //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
        lineJoin: "bevel", //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
        canvasWidth: document.documentElement.clientWidth - 92, //canvas宽高 [Number] 可选
        canvasHeight: document.documentElement.clientHeight, //高度  [Number] 可选
        isShowBorder: false, //是否显示边框 [可选]
        bgColor: "#f7f8fa", //背景色 [String] 可选
        borderWidth: 1, // 网格线宽度  [Number] 可选
        borderColor: "#ff787f", //网格颜色  [String] 可选
        writeWidth: 5, //基础轨迹宽度  [Number] 可选
        maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
        minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
        writeColor: "#101010", // 轨迹颜色  [String] 可选
        isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
        imgType: "png", //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
      },
    };
  },
  mounted: function () {
    // this.resizeScreen()
  },
  methods: {
    /**
     * 清除画板
     */
    canvasClear() {
      this.$refs.SignCanvas.canvasClear();
    },

    /**
     * 保存图片
     */
    saveAsImg() {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: "签字上传中...",
      });
      const img = this.$refs.SignCanvas.saveAsImg();
      this.loading = true;
      this.trimImage(img)
        .then((image) => uploadImage({ image }))
        .then((resp) => {
          Toast.clear();
          this.value = resp.result;
          this.$emit("done", this.value);
        })
        .catch(() => {
          this.loading = false;
          Toast.clear();
          this.$emit("done", this.false);
          Toast("上传失败，请检查网络后重试");
        });
    },

    /**
     * 裁剪签名图片的空白区域，只保留笔画部分后再上传
     */
    trimImage(dataUrl) {
      return new Promise((resolve) => {
        const image = new Image();
        image.onload = () => {
          try {
            const canvas = document.createElement("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0);
            const box = this.getInkBox(ctx, image.width, image.height);
            if (!box) return resolve(dataUrl);
            const padding = 24;
            const sx = Math.max(0, box.minX - padding);
            const sy = Math.max(0, box.minY - padding);
            const sw = Math.min(image.width, box.maxX + padding) - sx;
            const sh = Math.min(image.height, box.maxY + padding) - sy;
            // 压缩到宽 400px（不放大），高度按比例
            const scale = Math.min(1, 400 / sw);
            const out = document.createElement("canvas");
            out.width = Math.round(sw * scale);
            out.height = Math.round(sh * scale);
            out
              .getContext("2d")
              .drawImage(canvas, sx, sy, sw, sh, 0, 0, out.width, out.height);
            resolve(out.toDataURL("image/jpeg", 0.8));
          } catch (e) {
            resolve(dataUrl);
          }
        };
        image.onerror = () => resolve(dataUrl);
        image.src = dataUrl;
      });
    },

    /**
     * 计算笔画（与背景色差异明显的像素）的包围盒
     */
    getInkBox(ctx, width, height) {
      const { data } = ctx.getImageData(0, 0, width, height);
      const bg = [247, 248, 250]; // options.bgColor #f7f8fa
      let minX = width,
        minY = height,
        maxX = -1,
        maxY = -1;
      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          const i = (y * width + x) * 4;
          if (
            Math.abs(data[i] - bg[0]) > 12 ||
            Math.abs(data[i + 1] - bg[1]) > 12 ||
            Math.abs(data[i + 2] - bg[2]) > 12
          ) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }
      return maxX < 0 ? null : { minX, minY, maxX, maxY };
    },

    /**
     * 下载图片
     */
    downloadSignImg() {
      this.$refs.SignCanvas.downloadSignImg();
    },
    goBack() {
      this.$emit("done", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.index {
  background-color: #f5f5f5;
  display: flex;
  overflow: hidden;

  .sign-tools {
    width: 46px;
    height: 100vh;
    border-right: 1px dashed #cccccc;
    background-color: #ffffff;
    text-align: left;

    .btn-clear {
      display: inline-block;
      width: 100px;
      height: 46px;
      line-height: 46px;
      text-align: center;
      font-size: 14px;
      color: #f06357 !important;
      //color:#1989fa;
      transform: rotate(90deg);
      transform-origin: 0 0;
      margin-left: 46px;
      margin-top: calc(100vh - 100px);
    }
  }
  .sign-header {
    width: 46px;
    height: 100vh;
    background-color: grey;

    .van-nav-bar {
      margin-left: 46px;
      transform: rotate(90deg);
      transform-origin: 0 0;
      width: 100vh;
    }
  }

  .sign-canvas {
    flex: 1;
    background-color: green;
  }
}
</style>
